import React from 'react'

import { UseFormRegisterReturn, useWatch } from 'react-hook-form'
import { styled, css } from 'styled-components'

import TextInput from 'core/components/legacy/TextInput'
import { S } from 'core/helpers'

import { PeachOverrideName, PeachOverrideVariant } from './overrideOptions'

type OverrideProps = Omit<UseFormRegisterReturn<PeachOverrideName>, 'ref'> & {
  override: PeachOverrideVariant
}

const Override = React.forwardRef<any, OverrideProps>(({ override, ...props }, ref) => {
  const requirement = useWatch({ name: override.requires?.name ?? '', disabled: !override.requires })

  if (override.requires && requirement !== override.requires.value) return null

  switch (override.type) {
    case 'select':
      return (
        <>
          <StyledLabel>{S.sentenceCase(props.name)}</StyledLabel>
          <StyledSelectInput ref={ref} {...props}>
            {override.options.map((o) => (
              <option key={`${props.name}-${o}`} value={o}>
                {S.sentenceCase(o)}
              </option>
            ))}
          </StyledSelectInput>
        </>
      )
    case 'text':
      return (
        <>
          <StyledLabel>{S.sentenceCase(props.name)}</StyledLabel>
          <StyledTextInput placeholder={override.placeholder} ref={ref} {...props} />
        </>
      )
    case 'toggle':
      return (
        <StyledLabel htmlFor={props.name}>
          <input id={props.name} ref={ref} type='checkbox' {...props} />
          {S.sentenceCase(props.name)}
        </StyledLabel>
      )

    default:
      return null
  }
})

Override.displayName = 'Override'

export default Override

const inputStyles = css`
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 1px;
  background: #fff;
  padding: 2px 4px;
  width: 100%;
  font-size: 12px;
`

const StyledTextInput = styled(TextInput)`
  ${inputStyles}
`

const StyledSelectInput = styled.select`
  ${inputStyles}
`

const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: 12px;

  input {
    margin-right: 8px;
  }
`
